var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12066"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Youtube",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Youtube",
    width: 16,
    height: 16,
    fill: "currentColor",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_12066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.35 13.5L5.07 13.44C4.01 13.42 2.95 13.46 1.91 13.24C0.32 12.92 0.21 11.33 0.09 10C-0.07 8.14 0 6.23 0.3 4.38C0.47 3.34 1.15 2.72 2.2 2.65C5.74 2.41 9.3 2.44 12.83 2.55C13.2 2.56 13.58 2.62 13.94 2.68C15.76 3 15.8 4.8 15.92 6.31C16.04 7.84 15.99 9.37 15.76 10.89C15.58 12.14 15.24 13.2 13.79 13.3C11.97 13.43 10.19 13.54 8.36 13.51C8.36 13.5 8.35 13.5 8.35 13.5ZM6.42 10.32C7.79 9.53 9.14 8.76 10.5 7.97C9.13 7.19 7.79 6.41 6.42 5.63L6.42 10.32Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.ef0b719a73088316ed7118516c598a22.svg";
export { ForwardRef as ReactComponent };